export default __webpack_public_path__ + "static/media/Shatterfist.e7be956b.jpg";